import PageviewHandler from './PageviewHandler';

export default PageviewHandler;
